import CONTENTO_TYPES from 'app/domain/ContentoTypes';
import { ContentItemFragment } from 'app/graphql/__generated__/types/contento';
import AccessServiceTypes from '../../domain/AccessServiceTypes';

export const isSameAccessService = (
    accessService: AccessServiceTypes,
    preferredAccessVersion: AccessServiceTypes
): boolean => {
    switch (preferredAccessVersion) {
        case AccessServiceTypes.SIGNINTERPRETATION:
        case AccessServiceTypes.SIGN_LANGUAGE:
            return (
                accessService === AccessServiceTypes.SIGNINTERPRETATION ||
                accessService === AccessServiceTypes.SIGN_LANGUAGE
            );
        default:
            return accessService === preferredAccessVersion;
    }
};

export const getUrl = (content: any, preferredAccessVersion: AccessServiceTypes): string => {
    if (content.item?.urls?.svtplay) {
        if (content.item.variants) {
            for (let i = 0; i < content.item.variants.length; i++) {
                const variant = content.item.variants[i];
                if (isSameAccessService(variant.accessibility, preferredAccessVersion)) {
                    return variant.urls.svtplay;
                }
            }
        }

        return content.item.urls.svtplay;
    }

    return '/sida-saknas';
};

export const getHeading = (item: ContentItemFragment): string => {
    const typename = item.item?.__typename;

    if (typename === CONTENTO_TYPES.CLIP || typename === CONTENTO_TYPES.TRAILER) {
        return item.item.name;
    }

    return item.heading;
};

export const getSubHeading = (listId: string, item: ContentItemFragment): string => {
    if (listId === 'recommended') {
        return item.heading;
    }

    const typename = item.item?.__typename;

    if (
        typename === CONTENTO_TYPES.TVSERIES ||
        typename === CONTENTO_TYPES.TVSHOW ||
        typename === CONTENTO_TYPES.KIDSTVSHOW ||
        typename === CONTENTO_TYPES.SINGLE
    ) {
        return '';
    }

    return item.subHeading;
};
